class ProfessionalReviewItem {
    /**
     * Create a new instance of professionalreviewitem
     * @param {object} reviewData A professionalReviewItem object from novelist select
     */

     constructor(reviewData) {         
         this.id = reviewData.ID;
         this.issue = reviewData.Issue;
         this.review = reviewData.Review;
     }
}

export default ProfessionalReviewItem;


// WEBPACK FOOTER //
// ./src/models/ProfessionalReviewItem.js